import React from 'react'
import { Button } from '@workboard/wobo-ui'
import { useTranslation } from 'react-i18next';
import * as strategyUtils from  './../../../../utils/strategy';

export function Content(props) {
    let strategyIds = [];
    props.data.map((v)=>{
        strategyIds.push(strategyUtils.strategyPillar(v.strategyId,v.pillarId));    
    });
      strategyUtils.strategyEvent(strategyUtils.STRATEGY_EVENTS.OKR_VIEW, props.goalId,strategyIds);
  return (
    <div>
      {props.data.map((v,i) => {
        return (
          <div className="strategy_content" key={v.pillarId}
          tabIndex={0}
          onClick={(vs) => {
            strategyUtils.openPillar(v.strategyUrl, v.strategyId, v.pillarId, strategyUtils.STRATEGY_EVENTS.OKR_CLICK, props.goalId);
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              strategyUtils.openPillar(v.strategyUrl, v.strategyId, v.pillarId, strategyUtils.STRATEGY_EVENTS.OKR_CLICK, props.goalId);
            }
          }}>
            <div className="content_icon" >
              <img data-testid={`Pillar_Img_${i}`} src={`/wb/images/strategy/Pillar_type_${v.imageIcon}.svg`} />
            </div>
            <div className="content_Body">
              <div className="subtext-1" 
                aria-label={v.pillarName}>
              {v.pillarName || `${v.strategyName} Pillar Name`}
              </div>
              {v.strategyName  && 
              <div className="subtext-2"
                role='button'
                aria-label={`Strategy:${v.strategyName}`}
                aria-describedby={`Click on Strategy ${v.strategyName}`}
                data-testid={`strategy_Name_${i}`}
              >
                {' '}             
                Strategy: <span >{v.strategyName}</span>
              </div>
              }
            </div>
          </div>
        )
      })}
    </div>
  )
}

export function EmptyStrategy(props) {
  const arr1 = ['See how this Objective connects with the long range strategy', 'This Objective is currently linked to one or more strategic pillars. Find out more about how to view this connection.', 'Learn more'];
  const arr2 = ['No connection to long range strategy', 'This Objective is currently not linked to any strategic pillar. Align your short term goals with your long range strategy today. ', 'Link to strategic pillar']
  return (
    <div className="strategy_content">
      <div className="emptyBlock">
        <div className="EmptyImg">
          <img src="/wb/images/strategy/Illustrations.png" />
        </div>
        <div className="content_Body">
          <div className="subtext-E1"> {props.type == 1 ? arr1[0] : arr2[0]}</div>
          <div className="subtext-E2"> {props.type == 1 ? arr1[1] : arr2[1]}</div>
          <div className="btnLink">
            <Button
              kind="normal"
              variant="secondary"
              className="Linkbtn"
            >
              {props.type == 1 ? arr1[2] : arr2[2]}

            </Button>
          </div>
        </div>
      </div>

    </div>
  )
}
function Okrstrategy(props) {
  const strategy = Object.keys(props.OkrPopTabs).filter(k => props.OkrPopTabs[k].id == 'strategy')
  const { t } = useTranslation();
  return (
    <div className="strategy_block">
      {!props.OkrPopTabs[parseInt(strategy[0])].okrStrategy ? <EmptyStrategy type={1} /> :
        <div>
          <div className="strategy_ObjHeader"
            tabIndex={0}
            data-testid="strategy_header"
            aria-label={`${t('Objective')} is linked to the following pillars:`}>
            {t('Objective')} is linked to the following pillars:
          </div>
          <div className='strategy_scroll'>
            <Content data={props.OkrPopTabs[parseInt(strategy[0])].okrStrategy}  goalId={props.goalId}/>
          </div>
        </div>
      }
    </div>
  )
}

export default Okrstrategy
